export const CLEAR = '@billing/CLEAR';
export const BILLING_LIST_REQUEST = '@billing/BILLING_LIST_REQUEST';
export const BILLING_LIST_SUCCESSFUL = '@billing/BILLING_LIST_SUCCESSFUL';
export const BILLING_LIST_FAILED = '@billing/BILLING_LIST_FAILED';
export const BILLING_SET_FILTER = '@billing/BILLING_SET_FILTER';
